import InstitutionSectionWrapper from "./institution-section-wrapper";

export default InstitutionSectionWrapper;
